/**
 * atomberg-scroll-lock-recovery.js
 *
 * Horizon's dialog.js locks background scroll by setting
 * document.body.style.position = 'fixed' (+ width/top) while any <dialog>
 * (cart drawer, search modal, quick add, mobile menu) is open, and only
 * clears those styles after closeDialog() awaits the closing animation's
 * `animationend` event. If that never fires — e.g. the dialog is still
 * mid-close when the tab is backgrounded, or the animation is interrupted —
 * the lock is left on <body> forever.
 *
 * Setting `position` on <body> makes it the containing block for every
 * `position: fixed` descendant on the page, so once stuck, any fixed/sticky
 * element (the cart's Proceed bar, the PDP sticky ATC bar, etc.) silently
 * stops tracking the viewport and scrolls away with the page instead.
 *
 * This self-heals that state: if no <dialog> is actually open, clear the
 * lock styles dialog.js would have cleared itself. Does not modify dialog.js.
 */
(function () {
  /** @type {any} */
  var w = window;
  if (w._atombergScrollLockRecoveryInit) return;
  w._atombergScrollLockRecoveryInit = true;

  function recover() {
    if (document.body.style.position !== 'fixed') return;
    if (document.querySelector('dialog[open]')) return;
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recover);
  } else {
    recover();
  }

  // Catches the case where the tab was backgrounded mid-close (animationend
  // never fires while hidden) and the lock is still stuck once the user
  // returns.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') recover();
  });
})();
